import { render, staticRenderFns } from "./unionDialog.vue?vue&type=template&id=0d3d2373&"
import script from "./unionDialog.vue?vue&type=script&lang=js&"
export * from "./unionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports